import React, { useEffect } from "react";

import { Button } from 'reactstrap';
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelopeOpen } from '@fortawesome/free-solid-svg-icons';

export const ContactUsButton = (props) => {

    useEffect(() => {
    }, []);

    return (
        <AnchorLink href="#contactUs2" className="menu-item nav-link" offset="50">
            <Button outline size="lg"><FontAwesomeIcon icon={faEnvelopeOpen}></FontAwesomeIcon> Contact Us</Button>
        </AnchorLink>
    );
};
